export const FeatureText = {
    'Basic': [
        ['Up to 2 Textura canvases', 'Up to 2 Textura canvases'],
        ['Display own media up to 500MB', ''],
        ['Classic Creative Commons artwork (CC)', ''],
        ['Purchase artwork as priced', ''],
        ['Email & telephone support', ''],
    ],
    'Advanced': [
        ['Up to 10 Textura canvases', ''],
        ['Display own media up to 4GB', ''],
        ['Classic Creative Commons artwork (CC)', ''],
        ['Unlimited artwork', ''],
        ['Advanced artwork playlist (CC)', ''],
        ['Priority email & telephone support', ''],
        ['Allocated services manager', ''],
    ],
    'Premium': [
        ['Unlimited canvases', ''],
        ['Display media without limit', ''],
        ['Classic Creative Commons artwork (CC)', ''],
        ['Unlimited artwork', ''],
        ['Advanced artwork playlist (CC)', ''],
        ['Unlimited Premium Playlist', ''],
        ['Quarterly content curation**', ''],
        ['Content Management', ''],
        ['Dedicated Account Manager', ''],
        ['Allocated services manager', ''],
        ['Allocated designer', ''],
    ]
}

export const QAText = [
    ['Can I purchase the software and use on another digital screen?',
        ''],
    ['Do I need a software license for each canvas?',
        ''],
    ['Can I just purchase a Textura Canvas for my business without a software plan?',
        ''],
    ['How do I purchase additional Textura Canvases and software licenses as my business grows?',
        ''],
    ['Can I pay for the subscription monthly?',
        ''],
    ['After purchasing the Textura Canvas can I switch to a different plan?',
        ''],
    ['Do you offer trials of Vieunite Pro?',
        ''],
]